import { TableCell, Typography } from "@mui/material"
import {
  ActionButtonTrigger,
  type ColumnDefinition,
  type ColumnRenderDefinition,
  ListItemState,
  SortedTableCell,
  type useDialog,
} from "@pharmupp/p3-front-commons"
import { CheckCircle, Eye, Slash, Trash } from "react-feather"
import { FormNumberViews } from "../../core"
import type { ApiListExtraLabNewsFlash } from "../model"
import { newsFlashStatusesReferential } from "../referentials/newsFlashStatusesReferential"

export interface ExtraLabNewsFlashRowApi {
  handleDetail: (id: number) => void
  getBasePathById: (id: number) => string
  dialog: ReturnType<typeof useDialog>
}

const extraLabNewsFlashListRenderDef = {
  publicationDate: {
    renderHeader: ({ width, sortProps }) => (
      <SortedTableCell {...sortProps} columnName="publicationDate" width={width}>
        Date de publi
      </SortedTableCell>
    ),
    renderRow: ({ row }) => <TableCell>{row.publicationDate}</TableCell>,
  },
  title: {
    renderHeader: ({ width, sortProps }) => (
      <SortedTableCell {...sortProps} columnName="title" width={width}>
        Titre
      </SortedTableCell>
    ),
    renderRow: ({ row }) => (
      <TableCell>
        <Typography fontSize="inherit" fontWeight="bold">
          {row.title}
        </Typography>
      </TableCell>
    ),
  },
  views: {
    renderHeader: ({ width }) => <TableCell width={width}>Vues</TableCell>,
    renderRow: ({ row }) => (
      <TableCell>
        <FormNumberViews views={row.views} variant="compact" />
      </TableCell>
    ),
  },
  status: {
    renderHeader: ({ width }) => <TableCell width={width}>Statut</TableCell>,
    renderRow: ({ row }) => (
      <TableCell>
        <ListItemState value={row.status} options={newsFlashStatusesReferential} />
      </TableCell>
    ),
  },
  actions: {
    renderHeader: ({ width }) => <TableCell width={width} />,
    renderRow: ({ row, api }) => (
      <TableCell align="right">
        <ActionButtonTrigger
          IconProps={{ edge: "end" }}
          items={[
            {
              Icon: Eye,
              label: "Consulter",
              onClick: () => api.handleDetail(row.id),
            },
            {
              Icon: Slash,
              label: "Désactiver",
              onClick: () => {
                api.dialog.deactivate({
                  endpoint: `${api.getBasePathById(row.id)}/deactivate`,
                  onSuccess: api.refresh,
                })
              },
              hidden: !row.active,
            },
            {
              Icon: CheckCircle,
              label: "Activer",
              onClick: () =>
                api.dialog.activate({
                  endpoint: `${api.getBasePathById(row.id)}/activate`,
                  onSuccess: api.refresh,
                }),
              hidden: row.active,
            },
            {
              Icon: Trash,
              label: "Supprimer",
              onClick: () => {
                api.dialog.delete({
                  endpoint: api.getBasePathById(row.id),
                  onSuccess: api.refresh,
                })
              },
            },
          ]}
        />
      </TableCell>
    ),
  },
} satisfies Record<
  string,
  ColumnRenderDefinition<ApiListExtraLabNewsFlash, ExtraLabNewsFlashRowApi>
>

export const extraLabNewsFlashListColumns = [
  { renderDefinition: extraLabNewsFlashListRenderDef.publicationDate, width: "14%" },
  { renderDefinition: extraLabNewsFlashListRenderDef.title, width: "53%" },
  { renderDefinition: extraLabNewsFlashListRenderDef.views, width: "7%" },
  { renderDefinition: extraLabNewsFlashListRenderDef.status, width: "18%" },
  { renderDefinition: extraLabNewsFlashListRenderDef.actions, width: "8%" },
] satisfies ColumnDefinition<ApiListExtraLabNewsFlash, ExtraLabNewsFlashRowApi>[]
